import React from "react";
import { gql } from "@apollo/client";

import { styled, Tooltip, Stack, Divider } from "@mui/material";
import { Help as FeedbackIcon, Help as HelpIcon } from "mdi-material-ui";

const Icon = () => <FeedbackIcon />;

const Title = () => <span>Questionnaire de feedback</span>;

const Dt = styled("dt")(({ theme }) => ({
  float: "left",
  fontWeight: 700,
  marginRight: "0.5ch",
  color: theme.palette.primary.main,
}));

const Content = ({ orderEvent }) => {
  const feedback = orderEvent.soundShaping.feedback;

  return (
    <Stack component="dl" spacing={1} sx={{ m: 0 }}>
      <div>
        <Dt>Bec :</Dt>
        <dd>{orderEvent.soundShaping.mouthpieceRef.name}</dd>
      </div>

      <Divider />

      <div>
        <Dt>Testé :</Dt>
        <dd>{feedback.tested ? "Oui" : "Non"}</dd>
      </div>

      {feedback.notTestedComment && (
        <div>
          <Dt>Raison :</Dt>
          <dd>{feedback.notTestedComment}</dd>
        </div>
      )}

      {feedback.testConditions && (
        <div>
          <Dt>Conditions du test :</Dt>
          <dd>{feedback.testConditions}</dd>
        </div>
      )}

      {feedback.testConditionsOnceComment && (
        <div>
          <Dt>Test un seule fois :</Dt>
          <dd>{feedback.testConditionsOnceComment}</dd>
        </div>
      )}

      {feedback.tested && feedback.overallRating != null && (
        <div>
          <Dt>Note générale :</Dt>
          <dd>
            {parseFloat(feedback.overallRating).toFixed(2)} / 10
            <Tooltip
              placement="right"
              title={
                <span>
                  0 - nul
                  <br />
                  10 - parfait
                </span>
              }
            >
              <HelpIcon
                style={{ fontSize: "1em", marginLeft: "0.5ch", cursor: "help" }}
              />
            </Tooltip>{" "}
          </dd>
        </div>
      )}

      <Divider />

      {feedback.tested && feedback.previousMouthpieceComparison != null && (
        <div>
          <Dt>Bec N+1 :</Dt>
          <dd>{feedback.previousMouthpieceComparison}</dd>
        </div>
      )}

      {feedback.tested && feedback.lowRegister != null && (
        <div>
          <Dt>Graves :</Dt>
          <dd>{feedback.lowRegister}</dd>
        </div>
      )}

      {feedback.tested && feedback.mediumRegister != null && (
        <div>
          <Dt>Mediums :</Dt>
          <dd>{feedback.mediumRegister}</dd>
        </div>
      )}

      {feedback.tested && feedback.highRegister != null && (
        <div>
          <Dt>Aigus :</Dt>
          <dd>{feedback.highRegister}</dd>
        </div>
      )}

      {feedback.intonation && (
        <div>
          <Dt>Intonation :</Dt>
          <dd>{feedback.intonation}</dd>
        </div>
      )}

      {feedback.comfortComment && (
        <div>
          <Dt>Commentaire confort :</Dt>
          <dd>{feedback.comfortComment}</dd>
        </div>
      )}

      <Divider />

      {feedback.brightness != null && (
        <div>
          <Dt>Brillance :</Dt>
          <dd>{parseFloat(feedback.brightness).toFixed(2)} / 10</dd>
        </div>
      )}

      {feedback.power != null && (
        <div>
          <Dt>Puissance :</Dt>
          <dd>{parseFloat(feedback.power).toFixed(2)} / 10</dd>
        </div>
      )}

      {feedback.spread != null && (
        <div>
          <Dt>Largeur :</Dt>
          <dd>{parseFloat(feedback.spread).toFixed(2)} / 10</dd>
        </div>
      )}

      {feedback.tipOpening != null && (
        <div>
          <Dt>Ouverture :</Dt>
          <dd>{parseFloat(feedback.tipOpening).toFixed(2)} / 10</dd>
        </div>
      )}

      {feedback.homogeneity && (
        <div>
          <Dt>Homogénéité :</Dt>
          <dd>{feedback.homogeneity}</dd>
        </div>
      )}

      {feedback.homogeneityDetails && (
        <div>
          <Dt>Homogénéité (details) :</Dt>
          <dd>{feedback.homogeneityDetails}</dd>
        </div>
      )}

      {feedback.soundComment && (
        <div>
          <Dt>Commentaire son :</Dt>
          <dd>{feedback.soundComment}</dd>
        </div>
      )}

      <Divider />

      {feedback.finalDecision && (
        <div>
          <Dt>Décision finale :</Dt>
          <dd>{feedback.finalDecision}</dd>
        </div>
      )}

      {feedback.finalComment && (
        <div>
          <Dt>Commentaire final :</Dt>
          <dd>{feedback.finalComment}</dd>
        </div>
      )}
    </Stack>
  );
};

const fragments = {
  orderEvent: gql`
    fragment Orders_OrderEvent_FeedbackEvent_OrderEvent on OrderEvent {
      id

      ... on OrderEvent_Feedback {
        soundShaping {
          id
          mouthpieceRef {
            id
            name
          }
          feedback {
            id
            tested
            notTestedComment
            testConditions
            testConditionsOnceComment
            overallRating
            previousMouthpieceComparison
            lowRegister
            mediumRegister
            highRegister
            intonation
            comfortComment
            brightness
            power
            spread
            tipOpening
            homogeneity
            homogeneityDetails
            soundComment
            finalDecision
            finalComment
          }
        }
      }
    }
  `,
};

const Event = {
  Icon,
  Title,
  Content,
  fragments,
};

export default Event;
